import { InformationTooltip } from '@/src/components/InformationTooltip'
import TagComponent from '@/src/components/shared/tag/TagComponent'
import { appColors } from '@/src/theme/foundations/colors'
import { Button, Text } from '@chakra-ui/react'
import { BaseTooltip, FlexRow, NumberBox } from '@components'
import styled from '@emotion/styled'
import type { FC, ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { BaseText, type TextStyle } from '../../BaseText'

const FlexRowButton = styled(Button)`
  all: unset;
  display: flex;
  align-items: center;
  gap: 10px;
  flex-direction: row;
  cursor: pointer;
  &:hover, 
  &:active {
    background: none;
    box-shadow: none;
    outline: none;
  }
`

export type BetaTagConfig = {
  tooltipLabel?: string
}

type CardHeaderProps = {
  textKey: string
  textPlaceholderKey?: string
  titleIconLeft?: JSX.Element | null
  titleIconRight?: JSX.Element
  rightCornerText?: string | ReactNode
  countAfterTitle?: number
  children?: ReactNode
  infoTooltip?: string
  textStyle?: TextStyle
  onClickTextAndIcon?: () => void
  betaTagConfig?: BetaTagConfig
}

export const CardHeader: FC<CardHeaderProps> = ({
  textKey,
  textPlaceholderKey,
  rightCornerText,
  countAfterTitle,
  children,
  titleIconLeft,
  titleIconRight,
  infoTooltip,
  textStyle = 'lg/text-lg Semibold',
  onClickTextAndIcon,
  betaTagConfig,
}) => {
  const { t } = useTranslation()

  const Container = onClickTextAndIcon ? FlexRowButton : FlexRow

  return (
    <FlexRow justifyContent='space-between' width={'100%'}>
      <Container onClick={onClickTextAndIcon ?? undefined} alignItems={'center'} gap='10px'>
        {titleIconLeft}
        <FlexRow alignItems={'center'} gap='4px'>
          <BaseText variant='title' textStyle={textStyle} lineHeight='32px' color={appColors.foreground}>
            {t(textKey)}
          </BaseText>
          {textPlaceholderKey && (
            <BaseText color={'#B4B4B4'} textStyle={textStyle}>
              {t(textPlaceholderKey)}
            </BaseText>
          )}
          {infoTooltip && <BaseTooltip blackIcon label={infoTooltip} width={'16px'} height={'16px'} />}
        </FlexRow>
        {titleIconRight}
        {countAfterTitle !== undefined && countAfterTitle !== null && <NumberBox number={countAfterTitle} />}
        {betaTagConfig && (
          <TagComponent text={t('beta')} variant='warning' rightIcon={<InformationTooltip label={betaTagConfig.tooltipLabel} />} />
        )}
      </Container>
      <Text fontSize={14} color={appColors.foreground} fontWeight={500}>
        {rightCornerText}
      </Text>
      <FlexRow alignItems={'center'} gap='8px'>
        {children}
      </FlexRow>
    </FlexRow>
  )
}
